/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Weary_Salmon_StartleInputs */

const fr_extra_weary_salmon_startle = /** @type {(inputs: Extra_Weary_Salmon_StartleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateurs`)
};

/**

* @param {Extra_Weary_Salmon_StartleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_weary_salmon_startle = /** @type {((inputs?: Extra_Weary_Salmon_StartleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Weary_Salmon_StartleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_weary_salmon_startle(inputs)
});